var HaikuDOMAdapter = require('@haiku/core/dom')
module.exports = HaikuDOMAdapter(require('./code'))


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon1/code/main/dom.js
// module id = 428
// module chunks = 35783957827783